// ENG-1826: the CP signing page's notice above Submit when the field table holds the agreement; reason is cpBlockedReason's.
export function cpBlockedText(reason, stateName) {
  if (reason === "details-unavailable") return "Your details couldn't be loaded. Reload the page, or contact support if it keeps happening.";
  if (reason === "missing") return `Your license number for ${stateName} isn't on file. Contact support to add it.`;
  if (reason === "unavailable") {
    return `Your license number for ${stateName} couldn't be loaded. Reload the page, or contact support if it keeps happening.`;
  }
  return null;
}
